import { __rest } from "tslib";
import React from "react";
import { StyledButton } from "./styles";
import { hexToRgb } from "../../../utils/functions";
export var ActionButton = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, buttonColor = _a.buttonColor, rest = __rest(_a, ["icon", "onClick", "buttonColor"]);
    var rgbColor = hexToRgb(buttonColor || "#ff2c3a");
    return (React.createElement(StyledButton, { style: rest, buttonColor: rgbColor, onClick: function () { return onClick(); } }, icon));
};
//# sourceMappingURL=index.js.map